import { render } from "./Unauthorized.vue?vue&type=template&id=01dc4c8a&ts=true"
import script from "./Unauthorized.vue?vue&type=script&lang=ts"
export * from "./Unauthorized.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__